import React, { forwardRef } from "react";

type Props = React.PropsWithChildren<
	React.InputHTMLAttributes<HTMLInputElement>
>;

/**
 * Input コンポーネント
 * @returns {JSX.Element} Input コンポーネント
 */
export default forwardRef<HTMLInputElement, Props>(function Input(props, ref) {
	const { children, ...rest } = props;

	return <input ref={ref} {...rest} />;
});
